import {
    Box,
    Grid,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Tabs,
    Tab,
} from "@material-ui/core";
import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { Copyright } from "../components/Copyright";
import { Login } from "../components/Login";
import { Register } from "../components/Register";
import { RegisterPersonNumber } from "../components/RegisterPersonNumber";
import * as AuthenticationUtil from "../util/AuthenticationUtil";
import * as Endpoints from "../util/Endpoints";
import * as ApiUtil from "../util/ApiUtil";

import { usePageLoader } from '../util/usePageLoader';
import { useAlert } from '../util/useAlert';

import { useDocumentHtmlStyles, centeredPaperStyle } from "../components/ConsentDocumentBody";

import logo from "../images/logo-hpv-vaccination.png";

export const LoginPage = () => {

    const documentHtmlClasses = useDocumentHtmlStyles();

    const [redirectUrl, setRedirectUrl] = useState();
    const [proceedRedirect, setProceedRedirect] = useState();

    const [alert, showAlert] = useAlert();
    const [loader, showLoader, hideLoader] = usePageLoader();

    const [welcomeText, setWelcomeText] = useState();
    const [open, setOpen] = useState(true);

    const [regionList, setRegionList] = useState();
    const [siteList, setSiteList] = useState();

    /** 0 = Logga in, 1 = Registrera */
    const [mainTab, setMainTab] = useState(0);

    /** 0 = BankID, 1 = Lösenord — under Logga in */
    const [loginMethodTab, setLoginMethodTab] = useState(0);

    /** 0 = mobil + BankID, 1 = personnummer + lösenord — under Registrera */
    const [registerMethodTab, setRegisterMethodTab] = useState(0);

    useEffect(() => {
        const getWelcomeText = async () => {
            try {
                showLoader();
                const responseData = await ApiUtil.callBackend(Endpoints.welcomeThankYouText, "GET");

                if (!responseData.status) {
                    showAlert(responseData.message, "error");
                }
                setWelcomeText(responseData.data.welcome.welcomeTextSwedish);
            } catch (error) {
                console.log(error);
                showAlert(error.message, "error");
            } finally {
                hideLoader();
            }
        }
        getWelcomeText();
    }, []);

    useEffect(() => {
        const getRegion = async () => {
            try {
                showLoader();
                let apiUrl = Endpoints.regions;
                const responseData = await ApiUtil.callBackend(apiUrl, "GET");

                if (responseData.status) {
                    setRegionList(responseData.data.list);
                } else {
                    showAlert(responseData.message, "error");
                }
            } catch (error) {
                console.log(error);
                showAlert(error.message, "error");
            } finally {
                hideLoader();
            }
        }
        getRegion();
    }, []);


    useEffect(() => {
        const getSite = async () => {
            try {
                showLoader();
                let apiUrl = Endpoints.sites;
                const responseData = await ApiUtil.callBackend(apiUrl, "GET");

                if (responseData.status) {
                    setSiteList(responseData.data.list);
                } else {
                    showAlert(responseData.message, "error");
                }
            } catch (error) {
                console.log(error);
                showAlert(error.message, "error");
            } finally {
                hideLoader();
            }
        }
        getSite();
    }, []);


    if (AuthenticationUtil.isAuthenticated()) {
        return <Redirect to="/questionnaire" />;
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleMainTabChange = (_event, newValue) => {
        setMainTab(newValue);
        setLoginMethodTab(0);
        setRegisterMethodTab(0);
    };

    const goToRegisterTab = () => {
        setMainTab(1);
        setLoginMethodTab(0);
        setRegisterMethodTab(0);
    };

    const goToLoginTab = () => {
        setMainTab(0);
        setLoginMethodTab(0);
        setRegisterMethodTab(0);
    };

    const handleClickLogin = () => {
        const getRedirectUrl = async () => {
            try {
                showLoader();
                const responseData = await ApiUtil.callBackend(Endpoints.registrationUrl, "POST");

                if (!responseData.status) {
                    showAlert(responseData.message, "error");
                }
                setRedirectUrl(responseData.data.redirectResponse.redirectUrl);
                setProceedRedirect(true);
            } catch (error) {
                console.log(error);
                showAlert(error.message, "error");
            } finally {
                hideLoader();
            }
        }
        getRedirectUrl();
    };

    if (proceedRedirect && redirectUrl) {
        window.location = redirectUrl;
    }

    return (
        <div>
          <Box m={1}>
                <Grid container justifyContent="center" alignItems="center" spacing={1}>
                    <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
                        <img src={logo} height={90} alt="" />
                    </Grid>
                    <Grid item xs={12} style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <Paper style={centeredPaperStyle}>
                        <Box p={2}>
                            <Tabs
                                value={mainTab}
                                onChange={handleMainTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                            >
                                <Tab label="Logga in" />
                                <Tab label="Registrera" />
                            </Tabs>

                            <Box mt={2}>
                                {mainTab === 0 && (
                                    <>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={6}>
                                                <Button
                                                    fullWidth
                                                    disableElevation
                                                    variant={loginMethodTab === 0 ? "contained" : "outlined"}
                                                    color="primary"
                                                    onClick={() => setLoginMethodTab(0)}
                                                >
                                                    BankID
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Button
                                                    fullWidth
                                                    disableElevation
                                                    variant={loginMethodTab === 1 ? "contained" : "outlined"}
                                                    color="primary"
                                                    onClick={() => setLoginMethodTab(1)}
                                                >
                                                    Lösenord
                                                </Button>
                                            </Grid>
                                        </Grid>

                                        <Box
                                            mt={2}
                                            pt={2}
                                            style={{
                                                borderTop: "1px solid rgba(0, 0, 0, 0.08)",
                                            }}
                                        >
                                            {loginMethodTab === 0 && (
                                                <Box textAlign="center">
                                                    <Typography variant="body2" color="textSecondary" paragraph>
                                                        Du omdirigeras till BankID för att legitimera dig.
                                                    </Typography>
                                                    <Button color="primary" onClick={handleClickLogin}>
                                                        Fortsätt med BankID
                                                    </Button>
                                                </Box>
                                            )}
                                            {loginMethodTab === 1 && <Login />}
                                        </Box>

                                        <Box style={{ marginTop: 16, textAlign: "center" }}>
                                            <Typography variant="caption" component="span" color="textSecondary">
                                                Inget konto?{" "}
                                            </Typography>
                                            <Button
                                                variant="text"
                                                color="primary"
                                                size="small"
                                                onClick={goToRegisterTab}
                                                style={{ textTransform: "none", fontSize: "0.75rem", minWidth: 0, padding: "2px 4px", verticalAlign: "baseline" }}
                                            >
                                                Registrera
                                            </Button>
                                        </Box>
                                    </>
                                )}

                                {mainTab === 1 && (
                                    <>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={6}>
                                                <Button
                                                    fullWidth
                                                    disableElevation
                                                    variant={registerMethodTab === 0 ? "contained" : "outlined"}
                                                    color="primary"
                                                    onClick={() => setRegisterMethodTab(0)}
                                                >
                                                    BankID
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Button
                                                    fullWidth
                                                    disableElevation
                                                    variant={registerMethodTab === 1 ? "contained" : "outlined"}
                                                    color="primary"
                                                    onClick={() => setRegisterMethodTab(1)}
                                                >
                                                    Lösenord
                                                </Button>
                                            </Grid>
                                        </Grid>

                                        <Box
                                            mt={2}
                                            pt={2}
                                            style={{
                                                borderTop: "1px solid rgba(0, 0, 0, 0.08)",
                                            }}
                                        >
                                            {registerMethodTab === 0 && (
                                                <Grid>
                                                    <Register regionList={regionList} siteList={siteList} />
                                                </Grid>
                                            )}
                                            {registerMethodTab === 1 && (
                                                <Grid>
                                                    <RegisterPersonNumber regionList={regionList} siteList={siteList} />
                                                </Grid>
                                            )}
                                        </Box>

                                        <Box style={{ marginTop: 16, textAlign: "center" }}>
                                            <Typography variant="caption" component="span" color="textSecondary">
                                                Har du redan ett konto?{" "}
                                            </Typography>
                                            <Button
                                                variant="text"
                                                color="primary"
                                                size="small"
                                                onClick={goToLoginTab}
                                                style={{ textTransform: "none", fontSize: "0.75rem", minWidth: 0, padding: "2px 4px", verticalAlign: "baseline" }}
                                            >
                                                Logga in
                                            </Button>
                                        </Box>
                                    </>
                                )}
                            </Box>
                        </Box>
                    </Paper>
                    </Grid>
                </Grid>
              </Box>
         <Copyright />

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    style: { maxWidth: "min(560px, calc(100% - 32px))", margin: 16 },
                }}
            >
                <DialogTitle id="alert-dialog-title" disableTypography>
                    <Typography variant="subtitle1" component="span" style={{ fontWeight: 600 }}>
                        Välkommen
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography
                        id="alert-dialog-description"
                        variant="body2"
                        component="div"
                        color="textSecondary"
                    >
                        <div
                            className={documentHtmlClasses.documentHtml}
                            dangerouslySetInnerHTML={{ __html: welcomeText || "" }}
                        />
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" size="small">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            {alert}
            {loader}
        </div>
    );
};
